import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ToggleSwitch, Tooltip } from "@etframework/ui.components";
import { DateFormats } from "../../../types/DateFormats";
import moment from "moment-timezone";

export const AutoRolloverContent = forwardRef(
  (
    {
      autoRolloverData,
      title,
      showTooltip = true,
      tooltipMessage,
      onChange,
      show = false,
      message = "",
      ...rest
    },
    ref
  ) => {
    const { t, i18n } = useTranslation(["Preferences"]);
    moment.locale(i18n.language);

    tooltipMessage =
      tooltipMessage ?? t("SystemPreferences.AutoRolloverTooltip");

    const autoRolloverRef = useRef();

    const [showComponent, setShowComponent] = useState(show);
    const [taskTypeValue, setTaskTypeValue] = useState(null);

    useImperativeHandle(ref, () => ({
      setShowComponent,
      setTaskTypeValue,
      getValue: () => autoRolloverRef?.current.checked,
    }));

    if (!showComponent) return null;

    return (
      <>
        <div className="auto-rollover-content">
          <div className="d-flex align-items-center gap-3 m-2">
            <div className="icon-arrow">
              <i className="fa-regular fa-arrows-rotate et-darkest-gray mx-3"></i>
            </div>

            <div className="d-flex justify-content-start align-items-center gap-2 flex-grow-1">
              <div className="py-1">
                <div>
                  {title ?? (
                    <span className="fs-14 fw-600">
                      {t("SystemPreferences.AutoRollover")}
                    </span>
                  )}
                </div>
                <div>{message ?? <span className="fs-14">{message}</span>}</div>
              </div>
              {showTooltip && (
                <div>
                  <Tooltip
                    content={() => <div className="m-1">{tooltipMessage}</div>}
                    openDelay={500}
                    position="TopCenter"
                    showTipPointer={false}
                  >
                    <i className={`fa-regular fa-circle-info icon`}></i>
                  </Tooltip>
                </div>
              )}
            </div>

            <div className="d-flex justify-content-end flex-shrink-0 mx-2">
              {!autoRolloverData?.AutoRolloverCompletedAt ? (
                <ToggleSwitch
                  id={"auto-rollover-toggle-switch"}
                  name={"AutoRolloverToggleSwitch"}
                  ref={autoRolloverRef}
                  value={taskTypeValue ?? autoRolloverData?.AutoRollover}
                  checked={taskTypeValue ?? autoRolloverData?.AutoRollover}
                  change={onChange}
                  {...rest}
                />
              ) : (
                <div className="d-flex jsutify-content-start align-items-center gap-2 mx-3">
                  <i className="fa-regular fa-circle-check et-green-dark" />
                  {t("AppliedAutoRollover")}
                </div>
              )}
            </div>
          </div>
        </div>

        {autoRolloverData?.AutoRolloverCompletedAt && (
          <div className="et-darkest-gray fst-italic my-2">
            <div>{`${t("AutoRolloverCompletedAt")} ${moment(
              autoRolloverData?.AutoRolloverCompletedAt
            ).format(
              i18n.language == "en"
                ? DateFormats.MomentDescriptiveDateAndTimeFormat
                    .momentJsDayFormat_en
                : DateFormats.MomentDescriptiveDateAndTimeFormat
                    .momentJsDayFormat_es
            )}`}</div>
          </div>
        )}
      </>
    );
  }
);
